// @ts-nocheck

import { createSelector } from 'reselect';

import { type SelectorMaker, type Selector } from '../../../../types/selectors';
import { BoomAssetsBySkinId } from '../../constants/assets';
import { BoomLabelsBySkinId } from '../../constants/labels';
import {
  makeHistoryBoomDisabledSelector,
  makeHistoryBoomIdSelector,
  makeHistoryBoomSkinIdSelector,
  makeHistoryBoomStepIdSelector,
} from '../../selectors/history.selector';
import { type BoomSkinId } from '../../types/global';

type BoomHistoryBetslipPropsType = {
  skinId: BoomSkinId;
  label: string;
  icon?: string;
  isDisabled?: boolean;
  isVisible: boolean;
};

const makeBoomHistoryBetslipPropsSelector: SelectorMaker<BoomHistoryBetslipPropsType> = () => {
  const selectHistoryBoomSkinId = makeHistoryBoomSkinIdSelector();
  const selectHistoryBoomStepId = makeHistoryBoomStepIdSelector();
  const selectHistoryBoomId = makeHistoryBoomIdSelector();
  const selectHistoryBoomDisabled = makeHistoryBoomDisabledSelector();

  const selectLabel: Selector<string> = createSelector(
    [selectHistoryBoomSkinId, selectHistoryBoomStepId],
    (skinId, stepId) =>
      `${BoomLabelsBySkinId[skinId]?.BetslipBandTitle ?? ''} - ${
        BoomLabelsBySkinId[skinId]?.StepShortTitleByStepId[stepId] ?? ''
      }`,
  );

  const selectIcon: Selector<string | undefined> = createSelector(
    [selectHistoryBoomSkinId],
    (skinId) => BoomAssetsBySkinId[skinId]?.BetslipIcon,
  );

  return createSelector(
    [selectHistoryBoomSkinId, selectLabel, selectIcon, selectHistoryBoomId, selectHistoryBoomDisabled],
    (skinId, label, icon, boomId, isDisabled) => {
      return {
        skinId,
        label,
        icon,
        isDisabled,
        isVisible: !!boomId,
      };
    },
  );
};

export default makeBoomHistoryBetslipPropsSelector;
